module.exports = __webpack_public_path__ + "static/media/dropdown-outline.0a95424a.svg";